import { CartaConclusion, ICartaConclusion } from '@/shared/model/exbecarios/carta-conclusion.model';
import resolveEstadoSolicitudVariant from '@/shared/estados/estados.solicitud.util';

export interface ICartaNoAdeudo extends ICartaConclusion {
  totalApoyo?: number | null;
  totalGeneral?: number | null;
  totalModificado?: number | null;
}

export class CartaNoAdeudo extends CartaConclusion implements ICartaNoAdeudo {
  constructor(public totalApoyo?: number | null, public totalGeneral?: number | null, public totalModificado?: number | null) {
    super();
  }

  static fromObject(data: ICartaNoAdeudo): CartaNoAdeudo {
    const cartaNoAdeudo = CartaConclusion.fromObject(data) as CartaNoAdeudo;

    cartaNoAdeudo.totalApoyo = data.totalApoyo;
    cartaNoAdeudo.totalGeneral = data.totalGeneral;
    cartaNoAdeudo.totalModificado = data.totalModificado;

    cartaNoAdeudo.variant = resolveEstadoSolicitudVariant(cartaNoAdeudo?.estadoActual);

    return cartaNoAdeudo;
  }
}
